export { useLecture } from './use-lecture';
